import { useEffect } from "react";
import { useThree } from "@react-three/fiber";

import {
    TextureLoader,
    Mesh,
    // Vector3,
    // MirroredRepeatWrapping,
    Vector2,
    LatheGeometry,
    BackSide,
    MeshBasicMaterial,
    // PlaneGeometry,
    // MathUtils,
} from "three";

import { nature } from "textures";

// import grass from "textures/grass3.jpg";
// import sky from "textures/sky2.jpg";
// import { EquirectangularReflectionMapping } from "three";
// import { RGBELoader } from "three/addons/loaders/RGBELoader.js";
// import { useThree } from "@react-three/fiber";
// import { env } from "textures";

const Environment = ({ pos }) => {
    const { scene } = useThree();
    useEffect(() => {
        const points = [];
        for (let i = 0; i < 2; ++i) {
            points.push(new Vector2(20, i * 25));
        }
        const segments = 20;

        const phiStart = Math.PI * 0.15;

        const phiLength = Math.PI * 1.7;

        const environment = new TextureLoader().load(nature);

        const geometry = new LatheGeometry(points, segments, phiStart, phiLength);
        const material = new MeshBasicMaterial({
            map: environment,
            side: BackSide,
            // color: "rgb(175, 175, 175)",
            color: "rgb(215, 215, 227)",
            // color: "rgb(255, 255, 255)",
            // color: "rgb(0, 0, 0)",
        });
        const mesh = new Mesh(geometry, material);
        mesh.position.set(...pos);
        if (pos[1] === -13) mesh.rotation.set(Math.PI, 0, Math.PI);
        else mesh.rotation.set(Math.PI, Math.PI * 1.25, Math.PI);

        // const terr = new PlaneGeometry(35, 20, 16, 16);
        // const positions = terr.attributes.position;
        // for (var i = 0; i < positions.count; i++) {
        //     var vertex = new Vector3();
        //     vertex.fromBufferAttribute(positions, i);
        //     vertex.z = MathUtils.randFloat(-i / 1600, i / 1600);
        //     positions.setZ(i, vertex.z);
        // }

        // const grassTexture = new TextureLoader().load(grass);
        // grassTexture.repeat.set(1, 6);
        // grassTexture.wrapS = MirroredRepeatWrapping;
        // grassTexture.wrapT = MirroredRepeatWrapping;
        // const material2 = new MeshBasicMaterial({
        //     map: grassTexture,
        //     side: BackSide,
        //     color: "rgb(128, 128, 128)",
        // });

        // const mesh2 = new Mesh(terr, material2);
        // mesh2.rotation.set(Math.PI / 2, 0, 0);
        // mesh2.position.set(pos[0], pos[1] + 0.5, pos[2] + 12.5);

        // const plane = new PlaneGeometry(20, 35);
        // const skyTexture = new TextureLoader().load(sky);
        // skyTexture.repeat.set(1, 6);
        // skyTexture.wrapS = MirroredRepeatWrapping;
        // skyTexture.wrapT = MirroredRepeatWrapping;
        // const material3 = new MeshBasicMaterial({
        //     map: skyTexture,
        //     side: BackSide,
        //     color: "rgb(128, 128, 128)",
        // });

        // const mesh3 = new Mesh(plane, material3);
        // mesh3.position.set(pos[0], pos[1] + 13.5, pos[2] + 12.5);
        // mesh3.rotation.set(Math.PI * 1.5, 0, Math.PI / 2);

        // const env = [mesh];
        scene.add(mesh);

        // const { scene } = useThree();
        // const rgbeLoader = new RGBELoader();
        // rgbeLoader.load(env, (texture) => {
        //     texture.mapping = EquirectangularReflectionMapping;
        //     // texture.rotation = Math.PI;
        //     scene.background = texture;
        //     scene.environment = texture;
        // });
    }, [pos, scene]);

    // return env.map((mesh) => (
    //     <mesh
    //         key={mesh.uuid}
    //         rotation={mesh.rotation}
    //         position={mesh.position}
    //         geometry={mesh.geometry}
    //         material={mesh.material}
    //     />
    // ));
    return <></>;
};

export default Environment;
